import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2700" data-mp="1zhxkccfqsoyu">
      <div className="dark" data-id="element-2701" data-mp="1zi7ca5kcl676">
        <Hero data-id="element-2702" data-mp="1ziz73e64ezwe" />
      </div>
      <WhyUs data-id="element-2703" data-mp="1zjs4hoj6wd1v" />
      <ByTheNumbers data-id="element-2704" data-mp="1zkab9f3ha9o1" />
      <Services data-id="element-2705" data-mp="24gsc43votnv3" />
      <FAQ data-id="element-2706" data-mp="24g8u6n61ezh2" />
      <Reviews data-id="element-2707" data-mp="24i3f41hb6rl5" />
      <CtaBanner data-id="element-2708" data-mp="24hk7pepablld" />
    </main>;
}